import React, { useMemo } from 'react';
import { useAppSelector } from '../../../store/hooks';
import { selectProjectStatuses } from '../../../store/slices/mapSlice';
import DropDownSearchable from '../../dropDownSearchable';

const ProjectStatusCard = ({ project, onUpdate }) => {
    const {
        Project,
        ProjectDetails,
        init: { person },
    } = project;
    const projectStatuses = useAppSelector(selectProjectStatuses);

    const managerOptions = useMemo(() => {
        const people = [];
        for (let key in person) {
            if (person[key].family_name) {
                people.push({
                    label: `${person[key].given_name} ${person[key].family_name}`,
                    value: Number(key),
                });
            }
        }
        people.sort((a, b) => (a.label > b.label ? 1 : -1));
        return [{ label: 'not assigned', value: null }, ...people];
    }, [person]);

    const statusOptions = useMemo(
        () =>
            Object.keys(projectStatuses).map((key) => ({
                label: projectStatuses[key],
                value: key,
            })),
        [projectStatuses]
    );

    const selectedStatus = statusOptions.find(
        (opt) => opt.value == Project.status
    );
    const selectedManagerId = ProjectDetails?.development_manager_id || null;
    const selectedManager = managerOptions.find(
        (opt) => opt.value === selectedManagerId
    );

    const handleSelectStatus = (selected) => {
        onUpdate([
            {
                sectionName: 'Project',
                fieldName: 'status',
                value: Number(selected.value),
            },
        ]);
    };

    const handleSelectManager = (selection) => {
        onUpdate([
            {
                sectionName: 'ProjectDetails',
                fieldName: 'development_manager_id',
                value: selection.value,
            },
        ]);
    };

    return (
        <div>
            <h3 className="cardTitle">Status</h3>
            <div className="mt-1 d-flex justify-content-between align-items-center">
                <h4 className="fieldLabel">Current Status</h4>
                <div className="selectionContainer">
                    <DropDownSearchable
                        options={statusOptions}
                        value={selectedStatus}
                        onSelect={handleSelectStatus}
                        compact={true}
                    />
                </div>
            </div>
            <div className="mt-1 d-flex justify-content-between align-items-center">
                <h4 className="fieldLabel">Development Manager</h4>
                <div className="selectionContainer">
                    <DropDownSearchable
                        options={managerOptions}
                        sortOptions={false}
                        value={selectedManager}
                        onSelect={handleSelectManager}
                        compact={true}
                    />
                </div>
            </div>
        </div>
    );
};

export default ProjectStatusCard;
